import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { Grid, Header, Loader } from 'semantic-ui-react';
import classNames from 'classnames';
import InputWrapper from '../../../../../common/components/FormInputFields/InputWrapper/InputWrapper';
import * as activityActions from '../../../activity.actions';
import * as activitySelectors from '../../../activity.selectors';
import * as activityReducerDefaults from '../../../reducers/activity.reducer.defaults';
import './promoCodesGenerated.styles.less';
import * as activityConstants from '../../../activity.constants';
import PromoCodeImportedWrapper from './imported/PromoCodeImportedWrapper';
import ConfirmationDialog from '../../../../../common/components/ConfirmationDialog/ConfirmationDialog';

const REFRESH_INTERVAL_IN_SEC = 10;

class PromoCodesImportedTab extends React.PureComponent {
  intervalId = null;

  static propTypes = {
    actions: PropTypes.func,
    intl: PropTypes.object,
    promoCodeImportedBulks: PropTypes.arrayOf(PropTypes.object),
    activityValidationErrors: PropTypes.object,
    serverEntityKey: PropTypes.string,
    serverActivityId: PropTypes.string,
    activityStatus: PropTypes.string,
  };

  state = {
    showConfirmDialog: false,
    confirmationBulkIndex: undefined
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  componentDidMount() {
    this.initializeInterval();
  }

  initializeInterval() {
    this.getImportedBulkLoyaltyFileUrl();
    this.intervalId = setInterval(this.getImportedBulkLoyaltyFileUrl, REFRESH_INTERVAL_IN_SEC * 1000); //
  }


  isNewBulk = (index) => this.props.promoCodeImportedBulks[index].get(activityConstants.PROMO_CODE_BULK_IS_NEW)

  onConfirmationModalOpen = (index, bulk) => {
    if (bulk.get(activityConstants.STATUS) !== 'inactive' && this.getImportedBulkFileLoyaltyUrl(bulk) !== null) {
      this.setState({ showConfirmDialog: true, confirmationBulkIndex: index });
    }
  };

  deactivateBulk = (index) => {
    this.props.actions.updatePromoCodesBulkImportedFieldValue(activityConstants.STATUS, activityConstants.ACTIVITY_STATUS_INACTIVE, index);
    this.setState({ showConfirmDialog: false, confirmationBulkIndex: null });
  };

  getImportedFileSignedUrl(bulk, file) {
    const bulkDataFile = bulk.toJS().dataFile;
    let bucket;
    let objectName;

    if (file === 'loyalty') {
      bucket = bulkDataFile.loyaltyBucketName;
      objectName = bulkDataFile.loyaltyObjectName;
    } else {
      bucket = bulkDataFile.bucketName;
      objectName = bulkDataFile.objectName;
    }

    return this.props.actions.getBulkSignedUrl(objectName, bucket);
  }

  getImportedBulkLoyaltyFileUrl = () => {
    const isAnyOldImportedBulkWithoutLoyaltyUrl =
      this.props.promoCodeImportedBulks.some((bulk) =>
        bulk.getIn([
          activityConstants.PROMO_CODE_FILE_UPLOADED_DATA_FILE,
          activityConstants.PROMO_CODE_FILE_UPLOADED_BULK_LOYALTY_RESULT_URL
        ]) === null &&
        bulk.get(activityConstants.PROMO_CODE_BULK_IS_NEW) === false
      );

    if (isAnyOldImportedBulkWithoutLoyaltyUrl && this.props.activityStatus === activityConstants.ACTIVITY_STATUS_ACTIVE) {
      this.props.actions.getImportedFilesLoyaltyUrl(this.props.serverEntityKey, this.props.serverActivityId);
    }
  }

  getImportedBulkFileUploadedUrl = (bulk) => bulk.toJS().dataFile.url;

  getImportedBulkFileLoyaltyUrl = (bulk) => bulk.toJS().dataFile.loyaltyUrl;

  getBulkKey = (bulk) => bulk.toJS().key !== undefined

  addBulk = () => {
    const index = this.props.promoCodeImportedBulks.length + 1;
    const newBulk = activityReducerDefaults.getDefaultPromoCodeBulksImportedType(index);
    this.props.actions.addPromoCodesBulkImported(newBulk);
  };

  onBulkChangeFieldValue(fieldName, value, index) {
    this.props.actions.updatePromoCodesBulkImportedFieldValue(fieldName, value, index);
  }

  deleteBulk = (index) => {
    this.props.actions.removePromoCodesBulkImported(index);
  }

  openImportModal = (activeIndex) => {
    this.props.actions.promoCodesImportedModalOpen(activeIndex);
  };


  render() {
    const { formatMessage } = this.props.intl;
    const codeBulks = this.props.promoCodeImportedBulks;
    const errors = this.props.activityValidationErrors && this.props.activityValidationErrors.get(activityConstants.PROMO_CODE_BULKS) ? this.props.activityValidationErrors.get(activityConstants.PROMO_CODE_BULKS).toJS() : {};
    return (
      <Grid className="promoCode-generated">
        <Grid.Row>
          <Grid.Column width={14} className="left-label">
            <Header>{formatMessage({ id: 'promoCode.code.imported.title' })}</Header>
            <p className="hint-tip-label">
              {formatMessage({ id: 'promoCode.code.imported.subtitle' })}
            </p>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <div className="promoCode-generated-content">
            {codeBulks.map((bulk, index) => (
              <div
                className={classNames({
                  'promoCode-generated-row': true,
                  'deactivated': bulk.get(activityConstants.STATUS) === 'inactive',
                })}
              >
                <div className="promoCode-generated-index">{index + 1}.</div>
                <div className="promoCode-generated-input">
                  <InputWrapper
                    value={bulk.get(activityConstants.NAME)}
                    type="text"
                    onChange={(e, data) => this.onBulkChangeFieldValue(activityConstants.NAME, data.value, index)}
                    resetValueOnOverflow={false}
                    prefix={`promoCode.imported.row${index}.name`}
                    disabled={bulk.get(activityConstants.STATUS) === 'inactive'}
                    error={errors[index.toString()] ? errors[index.toString()].name : null}
                  />
                </div>
                {
                  this.getImportedBulkFileUploadedUrl(bulk) === null ?
                    <div
                      data-automation-id={`promoCode.imported.row${index}.upload.btn`}
                      className={errors[index.toString()] ? 'promoCode-generated-download error' : 'promoCode-generated-download'}
                      onClick={() => this.openImportModal(index)}
                    >
                      <i aria-hidden="true" className={'icon como-svg-promo-code-import-ic'} />
                      <span>{formatMessage({ id: 'upload.file' })}</span>
                    </div>
                    :
                    this.isNewBulk(index) === true ?
                      <div
                        data-automation-id={`promoCode.imported.row${index}.download.btn`}
                        className={'promoCode-generated-download'}
                      >
                        <i aria-hidden="true" className={'icon como-ic-export large'} />
                        <span onClick={() => this.getImportedFileSignedUrl(bulk, 'original')}> {formatMessage({ id: 'download.file' })}</span>
                      </div>
                      :
                      this.getImportedBulkFileLoyaltyUrl(bulk) !== null ?
                        <div
                          data-automation-id={`promoCode.imported.row${index}.download.btn`}
                          className={'promoCode-generated-download'}
                        >
                          <i aria-hidden="true" className={'icon como-ic-export large'} />
                          <span onClick={() => this.getImportedFileSignedUrl(bulk, 'loyalty')}> {formatMessage({ id: 'download.file' })}</span>
                        </div>
                        :
                        <div className="promoCode-generated-loader">
                          <Loader active size="medium" className="paste-loader" />
                        </div>
                }
                {
                  bulk.get(activityConstants.KEY) ?
                    <div
                      data-automation-id={`promoCode.imported.row${index}.deactivate.btn`}
                      className="promoCode-generated-deactivate"
                      onClick={() => this.onConfirmationModalOpen(index, bulk)}
                    >
                      <i aria-hidden="true" className="icon como-ic-deactivate" />
                      <span>{formatMessage({ id: 'promoCode.code.generated.row.deactivate' })}</span>
                    </div>
                    : null
                }
                {
                  !this.getBulkKey(bulk) && codeBulks.length > 1 ?
                    <div
                      data-automation-id={`promoCode.generated.row${index}.delete.btn`}
                      onClick={() => this.deleteBulk(index)}
                      className="promoCode-generated-deactivate"
                    >
                      <i aria-hidden="true" className="icon como-ic-delete" />
                      <span>{formatMessage({ id: 'promoCode.code.generated.row.delete' })}</span>
                    </div>
                    : null
                }
                <div className="promoCode-generated-deactivated-line" />
              </div>
            ))}
            <div className="promoCode-generated-add-bulk-button" onClick={this.addBulk}>
              <i aria-hidden="true" className="icon como-ic-plus-in-circle" />
              <span>{formatMessage({ id: 'promoCode.code.generated.row.addBulk' })}</span>
            </div>
          </div>
          <PromoCodeImportedWrapper>
          </PromoCodeImportedWrapper>
        </Grid.Row>
        <ConfirmationDialog
          className="apply-confirm-dialog-btn"
          automationIdPrefix="promoCode.imported.deactivate.bulk.confirmation-dialog"
          triggerLabelKey="general.button.apply"
          confirmButtonKey="general.button.apply"
          contentMessageKey="promoCode.generated.deactivate.bulk.confirmation-dialog.message"
          confirmAction={() => this.deactivateBulk(this.state.confirmationBulkIndex)}
          open={this.state.showConfirmDialog}
          cancelAction={() => { this.setState({ showConfirmDialog: false, confirmationBulkIndex: null }); }}
          titleKey="promoCode.generated.deactivate.bulk.confirmation-dialog.title"
          key="promoCode.generated.deactivate.bulk.confirmation-dialog"
        />
      </Grid>

    );
  }
}

const mapStateToProps = (state) => ({
  promoCodeImportedBulks: activitySelectors.getPromoCodeBulksImported(state).toArray(),
  activityValidationErrors: activitySelectors.getActivityValidationErrors(state),
  serverEntityKey: activitySelectors.getServerEntityKey(state),
  activityStatus: activitySelectors.getActivityStatus(state),
  serverActivityId: activitySelectors.getServerId(state)
});

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(activityActions, dispatch)
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  injectIntl,
  withConnect
)(PromoCodesImportedTab);
